import React, { Component } from 'react';
import { Modal, Spin, Table, Tooltip, Button, Icon } from 'antd';
import moment from 'moment';
import { openNotification } from '../../../util/notificaciones';
import CapturaCiclicaRequest from '../../../services/CapturaCiclica';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
moment.locale('es')

export default class DetalleDiferenciaCiclicoModal extends Component {
    state = {
        cargando: false,
        inventario: null,
        lineas: [],
        fechaUltimaSincronizacion: null,
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.visible && !prevProps.visible && this.props.idInventario) {
            this.cargarDetalle()
        }
    }

    cargarDetalle = () => {
        this.setState({ cargando: true }, () => {
            CapturaCiclicaRequest.ObtenerCaptura(this.props.idInventario).then(response => {
                this.setState({
                    cargando: false,
                    inventario: response.data.inventario,
                    lineas: response.data.detalles || [],
                    fechaUltimaSincronizacion: response.data.fecha_ultima_sincronizacion,
                })
            }).catch(err => {
                this.setState({ cargando: false })
                openNotification(err?.response?.data?.message, 'Error')
            })
        })
    }

    financial(x) {
        if (x === null || x === undefined || x === '') return '-'
        return Number.parseFloat(x).toFixed(2);
    }

    exportarExcel = () => {
        const { inventario, lineas } = this.state
        const timestamp = new Date().getTime()
        const fileName = `InventarioCiclico_${inventario.pdv_id}_${inventario.id}_${timestamp}`

        const datos = lineas.map(linea => ({
            Codigo: linea.codigo_articulo,
            Articulo: linea.descripcion,
            Unidad: linea.unidad_medida,
            InventarioInicial: linea.existencia_teorica,
            Bodega: linea.existencia_bodega,
            Cocina: linea.existencia_cocina,
            ConteoTotal: linea.conteo_total,
            Diferencia: linea.diferencia,
            // Motivo: linea.motivo_diferencia_nombre || '',
        }))

        const workbook = new ExcelJS.Workbook()
        const worksheet = workbook.addWorksheet('Hoja1')
        worksheet.columns = [
            { header: 'Código', key: 'Codigo', width: 15 },
            { header: 'Artículo', key: 'Articulo', width: 45 },
            { header: 'Unidad', key: 'Unidad', width: 10 },
            { header: 'Inventario Inicial', key: 'InventarioInicial', width: 16 },
            { header: 'Existencia Bodega', key: 'Bodega', width: 16 },
            { header: 'Existencia Cocina', key: 'Cocina', width: 16 },
            { header: 'Conteo Total', key: 'ConteoTotal', width: 14 },
            { header: 'Diferencia', key: 'Diferencia', width: 12 },
            // { header: 'Motivo', key: 'Motivo', width: 30 },
        ]
        worksheet.getRow(1).font = { bold: true }
        worksheet.addRows(datos)

        workbook.xlsx.writeBuffer().then(buffer => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            saveAs(blob, fileName + '.xlsx')
        }).catch(() => {
            openNotification("Ha ocurrido un error al generar el archivo de Excel.", "Error")
        })
    }

    handleClose = () => {
        this.setState({ inventario: null, lineas: [], fechaUltimaSincronizacion: null })
        this.props.onClose()
    }

    render() {
        const { visible } = this.props
        const { inventario, lineas, cargando, fechaUltimaSincronizacion } = this.state

        const columnas = [
            { title: "Código PT", dataIndex: "codigo_articulo", key: "codigo_articulo", width: 110 },
            { title: "Descripción", dataIndex: "descripcion", key: "descripcion", width: 220 },
            { title: "Unidad", dataIndex: "unidad_medida", key: "unidad_medida", align: 'center', width: 90 },
            {
                title: "Inventario inicial",
                dataIndex: "existencia_teorica",
                key: "existencia_teorica",
                align: 'center',
                render: (value) => (
                    <Tooltip title={
                        fechaUltimaSincronizacion
                            ? `Última sincronización: ${moment(fechaUltimaSincronizacion).format("DD/MM/YYYY, h:mm a")}`
                            : 'Sin información de última sincronización'
                    }>
                        <span>{this.financial(value)}</span>
                    </Tooltip>
                )
            },
            {
                title: "Existencia Bodega",
                dataIndex: "existencia_bodega",
                key: "existencia_bodega",
                align: 'center',
                width: 130,
                render: (value) => <span>{this.financial(value)}</span>
            },
            {
                title: "Existencia Cocina",
                dataIndex: "existencia_cocina",
                key: "existencia_cocina",
                align: 'center',
                width: 130,
                render: (value) => <span>{this.financial(value)}</span>
            },
            {
                title: "Conteo Total",
                dataIndex: "conteo_total",
                key: "conteo_total",
                align: 'center',
                render: (value) => <span>{this.financial(value)}</span>
            },
            {
                title: "Diferencia",
                dataIndex: "diferencia",
                key: "diferencia",
                align: 'center',
                render: (value) => <span>{this.financial(value)}</span>
            },
            // {
            //     title: "Motivo",
            //     dataIndex: "motivo_diferencia_nombre",
            //     key: "motivo_diferencia_nombre",
            //     width: 220,
            //     render: (value) => <span>{value || '-'}</span>
            // },
        ]

        return (
            <Modal
                title={
                    inventario
                        ? `Detalle de captura: ${inventario.tipo_frecuencia === 'diario' ? `Diario (${inventario.turno_nombre || ''})` : 'Semanal'}`
                        : ''
                }
                onCancel={this.handleClose}
                visible={visible}
                width={"85%"}
                maskClosable={false}
                centered={true}
                destroyOnClose
                footer={[
                    <Button
                        className="btnCancelar"
                        key="back"
                        onClick={this.handleClose}>
                        Regresar
                    </Button>
                ]}
            >
                <div style={{ textAlign: "right", width: "100%" }}>
                    <Button
                        className="btnVerCrearGuardar"
                        type="primary"
                        disabled={!lineas.length}
                        style={{ marginBottom: 20 }}
                        onClick={this.exportarExcel}
                    > Exportar Excel </Button>
                </div>
                <Spin
                    tip="Cargando..."
                    indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                    spinning={cargando}
                    style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                    <Table size="small"
                        locale={{ emptyText: 'No se han encontrado resultados' }}
                        rowKey={record => record.id}
                        columns={columnas}
                        dataSource={lineas}
                        pagination={false}
                        scroll={{ x: 1300, y: 500 }}
                    />
                </Spin>
            </Modal>
        )
    }
}
